import React from 'react';
import classNames from 'classnames';
import { ListGroupNavItem } from './ListGroupNavComponents';
import { ListGroup } from 'react-bootstrap';

const SitrepsPanel: React.FC<{
  navBack: () => void;
}> = ({ navBack }) => {
  return (
    <nav aria-label="secondary sidebar" className="second-panel">
      <div className="second-panel-back flex-column align-items-start gap-3">
        <div className="d-flex align-items-center">
          <i className={classNames('material-symbols-outlined', 'me-1')}>
            pets
          </i>
          <span>Situation Reports</span>
        </div>
        <button
          className="button button--secondary-fill border-0 bg-bglight w-100
          "
          onClick={navBack}
        >
          <i className="material-symbols-outlined me-2">arrow_back</i> Back
        </button>
      </div>
      <ListGroup>
        <ListGroupNavItem to={`/sitreps`} icon="tactic" label="List" end />
        <ListGroupNavItem
          to="/sitreps/sitrep_templates"
          icon="file_present"
          label="SITREP Templates"
        />
        <ListGroupNavItem
          to="/sitreps/section_templates"
          icon="bar_chart"
          label="Section Templates"
        />
      </ListGroup>
    </nav>
  );
};

export default SitrepsPanel;
